import { useModuleProjectContext } from 'common/contexts/useModuleProjectContext';
import { selectAccessToken } from 'common/store/slices/auth.slice';
import { useSelector } from 'react-redux';

function useApiHeaders() {
  const accessToken = useSelector(selectAccessToken);
  const { activeProject } = useModuleProjectContext();

  const { moduleProjectID } = activeProject ?? {};

  return {
    Authorization: 'Bearer ' + accessToken,
    ProjectID: moduleProjectID,
  } as unknown as Headers;
}

export default useApiHeaders;
